<template>
  <v-card
    xs12
    class="search-fields d-flex flex-row pa-2"
    column
    elevation="0"
    flat
    @keyup.enter="search"
  >
    <v-flex md2>
      <v-text-field
        v-model="query.search"
        prepend-inner-icon="mdi-magnify"
        hide-details
        flat
        solo
        rounded
        dense
        height="15"
        label="Search driver, post code and city"
        class="ml-2 bg-white"
        @change="search"
      />
    </v-flex>
    <v-flex md2>
      <councils-auto-complete
        :query="query"
        icon="true"
        classes="ml-2 pa-0 mb-0"
        @councilSelected="$emit('councilSelected')"
      />
    </v-flex>
    <v-flex md2>
      <v-select
        v-if="rideTypes"
        v-model="query.rideType"
        prepend-inner-icon="mdi-magnify"
        color="light"
        dense
        flat
        solo
        rounded
        :items="rideTypes"
        item-text="name"
        item-value="id"
        label="Ride Type"
        multiple
        hide-details
        class="ml-2 bg-white"
        @change="search"
      >
        <template v-slot:item="{ item, index}">
          <small class="pa-2">{{ item.name }}</small>
        </template>
        <template v-slot:selection="{ item, index }">
          <span v-if="index === 0">{{ item.name }}</span>
          <span
            v-if="index === 1"
            class="grey--text caption"
          >(+{{ query.rideType.length - 1 }} others)</span>
        </template>
      </v-select>
    </v-flex>
    <v-flex md2>
      <v-select
        v-model="query.plannerFilter"
        prepend-inner-icon="mdi-magnify"
        color="light"
        hide-details
        flat
        solo
        rounded
        dense
        :items="plannerFilterItems"
        item-text="name"
        item-value="id"
        label="Filter By"
        class="ml-2"
        @change="search"
      >
        <template v-slot:item="{ item, index}">
          <small class="pa-2">{{ item.name }}</small>
        </template>
      </v-select>
    </v-flex>
    <v-spacer />
    <v-btn-toggle
      v-model="query.pagination"
      class="mr-2 mt-2 mb-1"
    >
      <v-btn small>
        view all
      </v-btn>
    </v-btn-toggle>
    <v-btn
      class="mt-2 mb-1"
      color="primary"
      small
      @click="clear"
    >
      Clear Filters
    </v-btn>
  </v-card>
</template>

<script>
import axios from "axios";
import CouncilsAutoComplete from '../widget/input/CouncilsAutoComplete'

axios.defaults.withCredentials = true;

export default {
  name: "DriverPlannerSearchBox",
  components: {CouncilsAutoComplete},
  props: {
    query: Object,
  },
  data: function () {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      dates: [],
      rideTypes: null,
      plannerFilterItems: [
        {name: "All", id: "filter_all"},
        {name: "Online", id: "filter_online"},
        {name: "Should Be Online", id: "filter_should_be_online"},
        {name: "Day Off", id: "filter_day_off"},
        {name: "Break", id: "filter_break"},
        {name: "Private Trip", id: "filter_private_trip"},
        {name: "Preassigned", id: "filter_preassigned"},
        {name: "Online Soon", id: "filter_online_soon"},
        {name: "Likely Working", id: "filter_likely_working"},
        {name: "Locked Out", id: "filter_locked_out"},
      ],
    };
  },
  computed: {
    dateRangeText() {
      return this.dates.join(' ~ ')
    },
  },
  mounted: async function () {
    this.getTaxiInformation();
  },
  methods: {
    resetFilters() {
      this.query = {}
    },
    fromChanged: function (d) {
      this.query.after = d;
    },
    toChanged: function (d) {
      this.query.before = d;
    },
    search: function () {
      this.$emit("search");
    },
    clear: function () {
      this.$emit("clear");
    },
    getTaxiInformation: async function () {
      console.log("test");
      try {
        let url = `${this.$store.state.apiUrl}/taxi/getCouncilAndRideTypesForCreateTaxi`;
        let response = await axios.get(url, {
          params: {},
        });
        this.rideTypes = [];
        // this.rideTypes.push({
        //   name: "",
        //   id: -1
        // });
        this.rideTypes = this.rideTypes.concat(response.data.ride_types);
      } catch (error) {
        console.log(
            "Failed to get information required to create taxi " + error
        );
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}

.small-label .v-label {
  font-size: 14px !important;
}

.md2 > div:nth-child(1) > div:nth-child(1) > div:nth-child(1), div.md2:nth-child(3) > div:nth-child(1) > div:nth-child(1) > div:nth-child(1),.v-select--is-multi > div:nth-child(1) > div:nth-child(1) {
  background: #FFFFFF !important;
}


.v-input__control:nth-child(2) > div:nth-child(1) {
  background: #FFFFFF !important;
}

.v-autocomplete > div:nth-child(1) > div:nth-child(1) {
  background: #ffffff !important;
}

.bg-grey {
  background: #EEEEEE !important;
}
</style>
